import { useState } from "react";
import { useSelector } from "react-redux";
import Button from "shared/Button";
import UpdateBirthdayModal from "shared/modals/UpdateBirthdayModal";

import moment from "moment";
import styles from "./Birthday.module.scss";

export default function Birthday() {
    const user = useSelector((s) => s.auth.user);
    const [isModalShowing, setIsModalShowing] = useState(false);

    console.log("User: ", user);

    return (
        <>
            <div>
                <p className={styles.heading}>Your birthday</p>
                <p className={styles.birthday}>
                    {user.birthday
                        ? new Date(user.birthday).toLocaleDateString()
                        : "Not set"}
                </p>
                <Button
                    btnType="white"
                    className={styles.updateButton}
                    onClick={() => setIsModalShowing(true)}
                >
                    Update
                </Button>
            </div>
            <UpdateBirthdayModal
                birthday={
                    user.birthday
                        ? moment(user.birthday).format("DD/MM/YYYY")
                        : ""
                }
                open={isModalShowing}
                onClose={() => setIsModalShowing(false)}
            />
        </>
    );
}
